import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

import AuthService from 'cio/services/auth';
import EnvironmentService from 'cio/services/environment';
import AccountService from 'cio/services/account';
import MasqService from 'cio/services/masq';

export default class AuthenticatedAppRoute extends Route {
  @service account!: AccountService;
  @service auth!: AuthService;
  @service masq!: MasqService;
  @service environment!: EnvironmentService;

  redirect() {
    let { user } = this.auth;
    let localEnvironmentId = this.environment.local;
    let currentEnvironmentId;

    if (localEnvironmentId && user?.canAccessEnvironment(localEnvironmentId)) {
      currentEnvironmentId = localEnvironmentId;
    } else {
      let lastEnvironmentId = user?.belongsTo('lastEnvironment').id();

      // ignore user's last environment when masqing - it can be in a different account (CIO admin)
      if (!this.masq.isOn && lastEnvironmentId != null && user?.canAccessEnvironment(lastEnvironmentId)) {
        currentEnvironmentId = lastEnvironmentId;
      } else if (user?.defaultEnvironment != null) {
        currentEnvironmentId = user.defaultEnvironment.id;
      }

      this.environment.set('local', currentEnvironmentId);
    }

    if (currentEnvironmentId != null) {
      this.router.transitionTo('dashboard', currentEnvironmentId);
    }
  }
}
